<template>
    <div>
        <b-row>
            <b-col>
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Documentos</span>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col>
                                <strong
                                    >Demonstrativo Sintético (F028/05)
                                </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button ml-2"
                                    @click.stop="relatorioF02805()"
                                ></strong>
                            </b-col>
                            <b-col>
                                <strong
                                    >Relatório de Pagamentos SEBRAE (F028/06)
                                </strong>
                                <strong
                                    class="fa fa-print fa-lg icon-button ml-2"
                                    @click.stop="relatorioF02806()"
                                ></strong>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <b-modal
            id="modalDoc"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
            style="height: 50%; margin: 0"
        >
            <div slot="modal-title">Visualizar Documentos - {{ nomeDoc }}</div>
            <iframe
                v-if="arquivo"
                v-bind:src="arquivo"
                style="width: 100%; height: 600px"
            >
            </iframe>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConvenioServicos'

export default {
    props: {
        convenio: {
            type: Object
        }
    },

    data() {
        return {
            mostrarModal: false,
            arquivo: null,
            nomeDoc: ''
        }
    },

    methods: {
        relatorioF02805() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterRelatorio(
                this.convenio.idConvenio,
                'F02805'
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatório F028/05')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        relatorioF02806() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterRelatorio(
                this.convenio.idConvenio,
                'F02806'
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.visualizar(response, 'Relatório F028/06')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        visualizar(doc, nome) {
            this.nomeDoc = nome
            const blob = new Blob([doc], { type: 'application/pdf' })
            this.arquivo = window.URL.createObjectURL(blob)
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        }
    }
}
</script>